﻿import * as React from "react";
import { Slider as MaterialSlider, SliderProps, SliderThumb } from "@mui/material";
import { getDataProps, type WithDataProps } from "../../shared/utilities";

interface StyledThumbComponentProps extends React.HTMLAttributes<unknown> { }


const ThumbComponent: React.FC<StyledThumbComponentProps> = React.memo((props) => {
    const { children, ...rest } = props;
    return (
        <SliderThumb {...rest}>
            {children}
            <span className="MuiSlider-thumb-middle" />
        </SliderThumb>
    );
});

const Slider: React.FC<WithDataProps<SliderProps>> = (props: WithDataProps<SliderProps>) => <MaterialSlider slots={{ thumb: ThumbComponent }} valueLabelDisplay="on" {...props} {...getDataProps(props)} />

export default Slider;